/**
 * The time zone of the organization the user is signed in to (an IANA name from the organization's IAM
 * record, e.g. `Asia/Dhaka`). Calendar days the user picks are days in this zone: a day starts at local
 * midnight there, so in Bangladesh (UTC+6) 4 Oct starts at `2026-10-03T18:00:00Z`.
 *
 * `OrganizationTimeZoneGate` sets it before the signed-in app renders, and shows an error instead of the
 * app when the organization has no readable time zone: the device's zone is never used, since a day read
 * in the wrong zone would be saved as the wrong day. Outside the gate (sign-in pages) UTC stands in.
 */
let organizationTimeZone: string | undefined;

export const isValidTimeZone = (timeZone?: string | null): timeZone is string => {
  if (!timeZone) return false;
  try {
    new Intl.DateTimeFormat('en-US', { timeZone });
    return true;
  } catch {
    return false;
  }
};

export const setOrganizationTimeZone = (timeZone?: string | null): void => {
  organizationTimeZone = isValidTimeZone(timeZone) ? timeZone : undefined;
};

export const getOrganizationTimeZone = (): string => organizationTimeZone ?? 'UTC';
